<div class="app-main__inner">
  <div class="bb-list-view">
    <div class="card bb-fill-card">
      <div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
        <span class="fw-semibold"><i class="pe-7s-box2 me-2 text-primary"></i>Book Inventory</span>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-secondary">{{ records.length }} records</span>
          <button type="button" class="btn btn-sm btn-pdf" (click)="openCatalogue()" title="Generate book catalogue PDF">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
            Catalogue PDF
          </button>
        </div>
      </div>
      <div class="card-body p-0 bb-fill-body">

        <div class="text-center py-5" *ngIf="isListLoading">
          <div class="spinner-border text-primary"></div>
          <p class="mt-2 text-muted">Loading inventory...</p>
        </div>

        <vio-table-v2 *ngIf="!isListLoading" [tableData]="records" [tableConfig]="tableConfig">
        </vio-table-v2>

      </div>
    </div>
  </div>
</div>

<!-- ── Author / Category Books Panel ──────────────────────────────────────── -->
<div class="bm-hl-backdrop" *ngIf="showAuthorPanel" (click)="closeAuthorPanel()"></div>
<div class="bm-hl-panel" *ngIf="showAuthorPanel" (click)="$event.stopPropagation()">

  <div class="bm-hl-header">
    <div class="bm-hl-title">
      <i class="pe-7s-bookmarks me-2 text-primary"></i>{{ authorPanelTitle }}
    </div>
    <button type="button" class="bm-hl-close" (click)="closeAuthorPanel()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="bm-hl-body">

    <div class="text-center py-4" *ngIf="isAuthorPanelLoading">
      <div class="spinner-border text-primary spinner-border-sm"></div>
      <p class="text-muted small mt-2">Loading books…</p>
    </div>

    <div class="alert alert-danger py-2 px-3 small m-3" *ngIf="authorPanelError">
      <i class="pe-7s-attention me-1"></i>{{ authorPanelError }}
    </div>

    <div class="bm-hl-empty" *ngIf="!isAuthorPanelLoading && !authorPanelError && authorPanelBooks.length === 0">
      <i class="pe-7s-bookmarks bm-hl-empty-icon"></i>
      <p>No books found.</p>
    </div>

    <div *ngIf="!isAuthorPanelLoading && authorPanelBooks.length > 0">
      <p class="bm-hl-meta">{{ authorPanelBooks.length }} title(s) — click View Copies to see locations</p>
      <div class="bm-hl-book-card" *ngFor="let book of authorPanelBooks">
        <div class="bm-hl-book-header">
          <div class="bm-hl-book-icon"><i class="pe-7s-notebook"></i></div>
          <div class="bm-hl-book-info">
            <div class="bm-hl-book-name">{{ book.bookName }}</div>
            <div class="bm-hl-book-meta">
              <span class="bm-hl-code" *ngIf="book.bookId">{{ book.bookId }}</span>
            </div>
          </div>
          <div class="bm-hl-stats">
            <span class="bm-hl-stat bm-hl-stat-c" title="At Center">⌂ {{ book.available }}</span>
            <span class="bm-hl-stat bm-hl-stat-m" title="Issued">⇌ {{ book.issued }}</span>
          </div>
          <button class="bm-hl-view-btn" (click)="openBookCopies(book)">
            <i class="pe-7s-map-marker me-1"></i> View Copies
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- ── Copies Modal (stacks over author panel) ─────────────────────────────── -->
<div class="bm-hl-copies-bd" *ngIf="showCopiesModal" (click)="closeCopiesModal()"></div>
<div class="bm-hl-copies-modal" *ngIf="showCopiesModal" (click)="$event.stopPropagation()">

  <div class="bm-hl-cm-header">
    <div class="bm-hl-cm-title">
      <i class="pe-7s-map-marker me-2 text-primary"></i>Copy Locations
    </div>
    <button type="button" class="bm-hl-close" (click)="closeCopiesModal()">
      <i class="pe-7s-close"></i>
    </button>
  </div>

  <div class="bm-hl-cm-book-strip">
    <div class="bm-hl-cm-book-icon"><i class="pe-7s-notebook"></i></div>
    <div class="bm-hl-cm-book-info">
      <div class="bm-hl-cm-book-name">{{ copiesModalBook?.bookName }}</div>
      <div class="bm-hl-cm-book-meta">
        <span class="bm-hl-code" *ngIf="copiesModalBook?.bookId">{{ copiesModalBook.bookId }}</span>
        <span class="bm-hl-cm-author" *ngIf="copiesModalBook?.authorNames?.length">
          {{ copiesModalBook.authorNames.join(', ') }}
        </span>
      </div>
    </div>
    <div class="bm-hl-stats">
      <span class="bm-hl-stat bm-hl-stat-c" title="At Center">⌂ {{ copiesModalBook?.available }}</span>
      <span class="bm-hl-stat bm-hl-stat-m" title="Issued">⇌ {{ copiesModalBook?.issued }}</span>
      <span class="bm-hl-stat bm-hl-stat-t" title="Total">&#x2022; {{ copiesModalBook?.totalCopies }}</span>
    </div>
  </div>

  <div class="bm-hl-cm-body">

    <div class="bm-hl-cm-loading" *ngIf="copiesModalLoading">
      <div class="spinner-border spinner-border-sm text-primary"></div>
      <span>Loading copies…</span>
    </div>

    <div class="alert alert-danger py-2 px-3 small m-3" *ngIf="!copiesModalLoading && copiesModalError">
      <i class="pe-7s-attention me-1"></i>{{ copiesModalError }}
    </div>

    <div class="bm-hl-no-copies text-muted small"
         *ngIf="!copiesModalLoading && !copiesModalError && copiesModalBook?.copies?.length === 0">
      No inventory copies found for this book.
    </div>

    <table class="table table-sm bm-hl-copies-table mb-0"
           *ngIf="!copiesModalLoading && copiesModalBook?.copies?.length > 0">
      <thead>
        <tr><th>Sr No.</th><th>Status</th><th>Location</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let copy of copiesModalBook?.copies" [class]="copyRowClass(copy.status)">
          <td class="bm-hl-srno">{{ copy.bookSrNo }}</td>
          <td>
            <span class="bm-hl-badge" [ngClass]="'bm-hl-badge-' + copy.status">
              {{ copyStatusLabel(copy.status) }}
            </span>
          </td>
          <td class="bm-hl-location">{{ copy.location }}</td>
        </tr>
      </tbody>
    </table>

  </div>

</div>
